import React, { Suspense, lazy } from 'react'
import { Modal } from '@web/walter-ui-kit'
import { useModal } from '~contexts/ModalsContext'
import { ModalTypes } from '~contexts/ModalsContext/types'
import SuspenseLoader from '~components/SuspenseLoader'

const Content = lazy(() => import('./Content'))

function SocialReferralModal() {
    const { isOpen, hide } = useModal(ModalTypes.socialReferral)

    return (
        <Modal withHeaderBorder={false} dataPointer="social_referral_modal" isOpen={isOpen} size="s" onClose={hide}>
            <Suspense fallback={<SuspenseLoader type="modal" />}>
                <Content onClose={hide} />
            </Suspense>
        </Modal>
    )
}

export default SocialReferralModal
